import styled from "styled-components";

import type { ActivityGroupStatus } from "./ActivityDetailsGroup";
import { Colors } from "@smartsuite/types";

const STATUS_COLOR: Record<ActivityGroupStatus, string> = {
  is_success: Colors.bGreen,
  is_error: Colors.bRed,
  is_pending: Colors.bOrange,
  conditions_not_met: Colors.bPurple,
  rejected: Colors.bPink,
};

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 14px;
`;

export const StyledTitle = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const StyledStatus = styled.div<{ status: ActivityGroupStatus }>`
  margin-left: auto;
  height: 24px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  min-width: 99px;
  background-color: ${(props) => STATUS_COLOR[props.status]};
`;

export const StyledIcon = styled.div<{ isExpanded: boolean }>`
  display: flex;
  margin-right: 10px;
  transition: transform 100ms ease-in;
  transform: rotate(${(props) => (props.isExpanded ? 0 : "-90")}deg);
`;

export const StyledChildren = styled.div`
  padding-left: 26px;
  margin-top: 16px;
`;
